import React from "react";
import { Layout } from "antd";
import CASLogo from "./Images/CAS.png";
import WMOLogo from "./Images/WMO.png";
import { Grid } from "@mui/material";
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Footer } = Layout;

const Bottom = () => {
  const hasToken =
    typeof window !== "undefined" && Boolean(localStorage.getItem("access_token"));
  return (
    <Footer className="footer">
      <Grid container spacing={4} sx={{ textAlign: "left" }}>
        {/* Left Section: Logo and Project Info */}
        <Grid item xs={12} md={6}>
          <img
            src="https://www.commsci.psu.ac.th/wp-content/uploads/2023/09/logo-web-V2.0.svg"
            alt="WMO Logo"
            className="commsci-image"
            style={{ maxWidth: 190, height: "auto", marginBottom: 14 }}
          />
          <div className="text" style={{ lineHeight: 1.5, color: "#334155", fontSize: "16px" }}>
            สร้างสรรค์โดย โครงการวิจัย เรื่อง
            การศึกษาและสร้างสรรค์สื่อเพื่อเฝ้าระวังข้อมูลผิดพลาดสำหรับเครือข่ายผู้บริโภคภาคใต้
          </div>
          <div className="text" style={{ lineHeight: 1.4, color: "#64748b", fontSize: "16px", marginTop: 4 }}>
            (The Study and Media Creation to Misinformation Surveillance for
            Southern Consumer Network)
          </div>
          <div className="text" style={{ lineHeight: 1.5, color: "#334155", fontSize: "16px", marginTop: 4 }}>
            ภายใต้การสนับสนุนของกองทุนวิจัย คณะวิทยาการสื่อสาร
            มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตปัตตานี
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                backgroundColor: "#f8fafc",
                padding: "10px 16px",
                borderRadius: "14px",
                border: "1px solid #e2e8f0",
              }}
            >
              <img
                src={WMOLogo}
                alt="WMO Logo"
                className="partner-image"
                style={{ width: 52, height: 52, objectFit: "contain" }}
              />
              <div className="text" style={{ fontSize: "16px", lineHeight: 1.3 }}>
                <strong style={{ color: "#208b99", fontSize: "16px" }}>
                  เครือข่ายเฝ้าระวังสื่อออนไลน์ภาคใต้
                </strong>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                backgroundColor: "#f8fafc",
                padding: "10px 16px",
                borderRadius: "14px",
                border: "1px solid #e2e8f0",
              }}
            >
              <img
                src={CASLogo}
                alt="CAS Logo"
                className="partner-image"
                style={{ width: 52, height: 52, objectFit: "contain" }}
              />
              <div className="text" style={{ fontSize: "16px", lineHeight: 1.3 }}>
                <strong style={{ color: "#208b99", fontSize: "16px" }}>
                  สมาคมผู้บริโภคสงขลา
                </strong>
              </div>
            </div>
          </div>
        </Grid>

        {/* Middle Section: Navigation Menu */}
        <Grid item xs={12} sm={3} md={2}>
          <div className="text" style={{ textAlign: "left", fontSize: "16px" }}>
            <div style={{ color: "#2e8555", fontSize: "18px", fontWeight: 700, fontFamily: "'Prompt', 'Sarabun', sans-serif", display: "block", marginBottom: "10px" }}>
              เมนูหลัก
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Link to="/" style={{ color: "#475569", textDecoration: "none", fontWeight: 600 }}>
                หน้าหลัก
              </Link>
              <Link to="/News_Menu" style={{ color: "#475569", textDecoration: "none", fontWeight: 600 }}>
                ข่าวสาร
              </Link>
              <Link to="/Article_Menu" style={{ color: "#475569", textDecoration: "none", fontWeight: 600 }}>
                บทความ
              </Link>
              <Link to="/MediaShare_Menu" style={{ color: "#475569", textDecoration: "none", fontWeight: 600 }}>
                สื่อชวนแชร์
              </Link>
              <Link to={hasToken ? "/FakeNews_Menu" : "/Warn"} style={{ color: "#475569", textDecoration: "none", fontWeight: 600 }}>
                แจ้งข่าวปลอม
              </Link>
              <Link to="/About_Us_View" style={{ color: "#475569", textDecoration: "none", fontWeight: 600 }}>
                เกี่ยวกับเรา
              </Link>
            </div>
          </div>
        </Grid>

        {/* Right Section: Contact Information */}
        <Grid item xs={12} sm={3} md={4}>
          <div className="text" style={{ textAlign: "left", lineHeight: 1.6, fontSize: "16px" }}>
            <div style={{ color: "#2e8555", fontSize: "18px", fontWeight: 700, fontFamily: "'Prompt', 'Sarabun', sans-serif", display: "block", marginBottom: "10px" }}>
              ติดต่อโครงการวิจัย
            </div>
            <div style={{ color: "#475569" }}>
              คณะวิทยาการสื่อสาร มหาวิทยาลัยสงขลานครินทร์
              <br />
              วิทยาเขตปัตตานี อำเภอเมือง จังหวัดปัตตานี 94000
            </div>
            <div style={{ marginTop: "10px", color: "#1e293b", fontWeight: 600 }}>
              <PhoneOutlined style={{ color: "#2e8555", marginRight: 8 }} />
              โทร. 073 349 692
              <br />
              <MailOutlined style={{ color: "#208b99", marginRight: 8 }} />
              Email: checkkonproject@gmail.com
            </div>
          </div>
        </Grid>
      </Grid>

      <div
        style={{
          textAlign: "center",
          marginTop: 28,
          paddingTop: 18,
          borderTop: "1px solid #f1f5f9",
          color: "#94a3b8",
          fontSize: 16,
          width: "100%",
          maxWidth: 1400,
        }}
      >
        © {new Date().getFullYear()} CheckKonProject — รู้เท่าทันสื่อ Checkก่อน. All rights reserved.
      </div>
    </Footer>
  );
};

export default Bottom;
